import styled from 'styled-components';

import { media } from '../../styles/media';

export const Root = styled.div``;

export const Header = styled.div``;

export const Content = styled.div``;
